// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"4460":"0aac1b571000f8d33706","5945":"5aed414f68d1700c7844","7925":"ab2b2002821df6001296"}[chunkId] + ".css";
};